import React, { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Box, Skeleton } from '@mui/material'

// Lazy load the Transactions component
const LazyTransactions = React.lazy(() => import('@/modules/transactions'))

// Loading fallback component
const TransactionsLoadingFallback = () => (
  <Box sx={{ p: 2, width: '100%' }}>
    <Skeleton variant="rectangular" width="30%" height={40} sx={{ mb: 2 }} />
    <Skeleton variant="rectangular" width="20%" height={20} sx={{ mb: 3 }} />
    <Skeleton variant="rectangular" width="100%" height={400} />
  </Box>
)

export const Route = createFileRoute('/_public/_layout/transactions/')({
  component: () => (
    <Suspense fallback={<TransactionsLoadingFallback />}>
      <LazyTransactions />
    </Suspense>
  ),
})
